import { Directive, Inject, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Directive({
  standalone: false,
  selector: '[libphonenumber]',
  exportAs: 'afterContentInit'
})
export class LibPhoneNumberDirective implements OnInit {
  private readonly _libUrl = 'https://cdn.cakeiteasy.com/libphonenumber.min.js';

  constructor(
    @Inject(DOCUMENT) private readonly _document: any,
    private _templateRef: TemplateRef<any>,
    private _viewContainer: ViewContainerRef
  ) {
  }

  ngOnInit() {
    this._init();
  }

  private async _init(maxCallingSize = 10) {
    const isLibAdded = Boolean(this._document.querySelector(`script[src='${this._libUrl}']`));
    const isLibReady = Boolean(window && window['libphonenumber']);

    if (isLibReady) {
      this._viewContainer.createEmbeddedView(this._templateRef);
    } else if (isLibAdded) {
      if (maxCallingSize < 0) {
        this._viewContainer.clear();
        console.error('libphonenumber can\'t be used');
        return;
      }
      setTimeout(() => this._init(maxCallingSize--), 500);
    } else {
      try {
        await this._loadLibPhoneNumber(this._libUrl);
        await this._init();
      } catch (err) {
        this._viewContainer.clear();
        console.log(err);
      }
    }
  }

  private _loadLibPhoneNumber(libUrl: string) {
    return new Promise(resolve => {
      const script = this._document.createElement('script');
      script.src = libUrl;
      script.onload = resolve;
      this._document.head.appendChild(script);
    });
  }

}
